import { accounts } from './accounts.fixture';

export const accountAdditionalData = {
  account_01: {
    balance: {
      available: [
        { amount: 1000, currency: 'usd' },
        { amount: 500, currency: 'gbp' },
      ],
      pending: [
        { amount: 1000, currency: 'usd' },
        { amount: 500, currency: 'gbp' },
      ],
    },
    stripeAccount: {
      requirements: {},
      settings: {
        payments: {
          statement_descriptor: 'STATEMENT DESC',
        },
      },
    },
  },
  account_02: {
    balance: {
      available: [{ amount: 0, currency: 'usd' }],
      pending: [{ amount: 0, currency: 'usd' }],
    },
    stripeAccount: {
      requirements: {
        disabled_reason: 'requirements.past_due',
      },
      settings: {
        payments: {
          statement_descriptor: 'STATEMENT DESC',
        },
      },
    },
  },
  account_03: {
    balance: {
      available: [{ amount: 0, currency: 'usd' }],
      pending: [{ amount: 0, currency: 'usd' }],
    },
    stripeAccount: {
      requirements: {
        disabled_reason: 'requirements.past_due',
      },
      settings: {
        payments: {
          statement_descriptor: 'STATEMENT DESC',
        },
      },
    },
  },
};

export const getAccountAccounts = accounts.content.reduce((result, account) => {
  result[account.accountId] = {
    ...account,
    ...accountAdditionalData[account.accountId],
  };
  return result;
}, accountAdditionalData);
